module.exports = __webpack_public_path__ + "img/thumbnail_RedDeer_j_normal.320d1aa0.png";